<template lang="pug">
  .container.col-centered
    .row
      //- h1.main_title Firmware change log
      .col-xs-12
        h1.main_title {{dynamicTitle}}
      .col-xs-12.function_bar
        .form-group
          label.control_label
            | Date:
          v-select(v-bind:value.sync='logFilter.date.value' v-bind:options='logFilter.date.opts')
        .form-group
          label.control_label
            | Category:
          v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
        .form-group(v-if="$route.name === 'smart-controller'")
          label.control_label
            | Domain:
          v-select(v-bind:value.sync='logFilter.domain.value' v-bind:options='logFilter.domain.opts')
        .form-group(v-if="$route.name === 'smart-controller'")
          label.control_label
            | Model:
          v-select(v-bind:value.sync='logFilter.model.value' v-bind:options='logFilter.model.opts')
        .form-group
          label.control_label
            | Custom:
          v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
        .upload
          button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
            span.glyphicon.glyphicon-plus
            span  New
      .col-xs-12
        pagination(
          v-bind:sort-method.sync="sortMethod"
          v-bind:sort-method-opts="sortMethodOpts"
          v-bind:count-of-page.sync="countOfPage"
          v-bind:curr-page.sync="currPage"
          v-bind:count-of-pagination="countOfPagination"
          v-bind:curr-pagination-sec.sync='currPaginationSec'
          v-bind:target-ary.sync='customFilteredTotalLog'
        )
        //- span {{pi | json}}
        //- span {{firmware | json}}
        //- span {{customFilteredTotalLog[0] | json}}
        //- span {{switch | json}}
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in customFilteredTotalLog | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media
                .media-left
                  .media-object.device_icon.smart-controller(v-bind:class="p.domain" v-if="p.model !== 'all'")
                    img(v-bind:src="getIconSrc(p.category)")
                  .media-object.device_icon(v-bind:class="p.domain" v-else)
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body
                  .media-top
                    //- span {{p.updatedAt | timeFormat}}
                    span.version {{p.version}}
                    span.time
                      span.glyphicon.glyphicon-time
                      span Updated {{p.updatedAt | fromNow}}
                    span.model.type_tag.base_black.base_grey_bg {{getCustomForUI(p.custom)}}
                    span.model.type_tag.base_grey_bg(v-if="$route.name === 'smart-controller' && p.domain != null" v-bind:class="p.domain") {{p.domain}}
                    //- span {{p.url}}
                    .action_buttons.pull-right
                      .btn-group
                        button.btn.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-default(@click="handleShowDeleteConfirm(p['.key'], p.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        a.btn.btn-default(v-if="p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin'" v-on:click='handleDownload(p.url, $event)')
                          span.glyphicon.glyphicon-cloud-download
                          span(v-if="$route.name === 'switch'")  Firmware
                          span(v-else)  Download
                        a.btn.btn-default(v-if="$route.name === 'switch' && (p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin')" v-on:click='handleDownload(p.testReportUrl, $event)')
                          span.glyphicon.glyphicon-list-alt
                          span  Test Report
                  .media-middle
                    line-table(title='Features:' v-bind:content='p.feature' v-if='p.feature.length !== 0')
                    line-table(title='BugFixes:' v-bind:content='p.bugFixed' v-if='p.bugFixed.length !== 0')
                .media-right.badge_group
                  .customized__badge(v-bind:class="{'dev': p.status === 'dev', 'release': p.status === 'release', 'beta': p.status === 'beta', 'disabled': p.status === 'disabled'}")
                    span {{p.status}}
    modal(
      v-bind:title.sync='modalTitle'
      v-bind:ok-text.sync='okText'
      backdrop='false'
      v-bind:callback='modalCb'
      v-bind:show.sync='showModal')
      .modal-body.upload_modal(slot='modal-body')
        .col-xs-12.clearfix.col-centered
          .form-group.col-xs-12.clearfix(v-if='isUpdate')
            .col-md-3.form_label.clearfix
              label.control_label
                | Last update:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='isUpdatedAt' readonly)
          .form-group.col-xs-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Category:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='category' v-bind:value.sync='selectedCategory')
          .form-group.col-xs-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Custom:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='customOpts' v-bind:value.sync='selectedCustom')
          .form-group.col-xs-12.clearfix(v-if="selectedCategory === 'smart-controller'")
            .col-md-3.form_label.clearfix
              label.control_label
                | Domain:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='domainOpts' v-bind:value.sync='selectedDomain')
          .form-group.col-xs-12.clearfix(v-if="selectedCategory === 'smart-controller'")
            .col-md-3.form_label.clearfix
              label.control_label
                | Model:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='modelOpts' v-bind:value.sync='selectedModel')
          .form-group.col-xs-12.clearfix.version
            .col-md-3.form_label.clearfix
              label.control_label
                | Version:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='version' v-bind:placeholder.sync='versionPlaceholder' v-bind:class="{'error': showInvalidMsg}")
              span.text-danger(v-if='showInvalidMsg')
                | Please follow the format of placeholder
          div(v-if="$route.name === 'smart-controller'")
            .form-group.col-xs-12.clearfix
              .col-md-3.form_label.clearfix
                label.control_label.download
                  | Download Link:
              .col-md-9.no_pad.clearfix
                input.form-control.input-sm(v-model='url' placeholder='www.google.com')
          div(v-else)
            .form-group.col-xs-12.clearfix
              .col-md-3.form_label.clearfix
                label.control_label
                  | Firmware
                  span.glyphicon.glyphicon-cloud-download
                  | :
              .col-md-9.no_pad.clearfix
                input.form-control.input-sm(v-model='url' placeholder='www.google.com')
            .form-group.col-xs-12.clearfix
              .col-md-3.form_label.clearfix
                label.control_label
                  | Test Report:
              .col-md-9.no_pad.clearfix
                input.form-control.input-sm(v-model='testReportUrl' placeholder='www.google.com')
          .form-group.col-xs-12.clearfix.version
            .col-md-3.form_label.clearfix
              label.control_label
                | MD5:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='md5')
          .form-group.col-xs-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Status:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='status' v-bind:value.sync='selectedStatus')
          .form-group.col-xs-12.clearfix.larger_form_group
            .col-md-3.form_label.clearfix
              label.control_label
                | Feature:
            .col-md-9.no_pad.clearfix
              textarea.form-control(v-model='feature' placeholder='[TopologyView] support LLDP discover\n[EventLog] Cold Start Log.')
          .form-group.col-xs-12.clearfix.larger_form_group
            .col-md-3.form_label.clearfix
              label.control_label
                | Bug Fixed:
            .col-md-9.no_pad.clearfix
              textarea.form-control(v-model='bugFixed' placeholder='[MSTP] If VLAN trunk is not the same to each other, the topology will loop.')
    modal(
      title='Confirm delete'
      v-bind:show.sync='showDeleteConfirm')
      .modal-body(slot='modal-body')
        h4
          | This operation is&nbsp;
          span.warning irreversible
        h4 Do you want to continue?
      .modal-footer(slot='modal-footer')
        button.btn.btn-default(@click='showDeleteConfirm = false')
          | Cancel
        button.btn.btn-danger(@click='applyDelete')
          | Yes, delete it
</template>
<script>
import moment from 'moment'
import { modal, select } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { store, getFwSwitchRef, getFWPiRef, getFirmwareRef, getFireBase, getModelForUI, getCustomForUI, filterOptions, naturalSorting } from '../../index.js'
import _ from 'lodash'
const fb = getFireBase()
const PI = 'smart-controller'
const SWITCH_CATEGORY = filterOptions.firmware.category
const PI_CATEGORY = [
  {label: 'Smart-controller', value: PI}
]
const PI_CUSTOM = [
  {label: 'Gomax', value: 'gomax'},
  {label: 'Gofanco', value: 'gofanco'}
]
const SWITCH_CUSTOM = filterOptions.firmware.custom

export default {
  components: {
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable
  },
  vuex: {
    getters: {
      user: state => state.user,
      firmwareInfo: state => state.firmware
    }
  },
  data () {
    return {
      dynamicTitle: '',
      countOfPage: 100,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      postFix: {
        all: '',
        ite: 'i',
        aspeed: 'a'
      },
      category: [],
      selectedCategory: PI,
      selectedCustom: 'gomax',
      selectedStatus: 'dev',
      selectedDomain: 'intri',
      selectedModel: 'all',
      version: '',
      customOpts: [],
      domainOpts: [],
      modelOpts: [],
      url: '',
      testReportUrl: '',
      feature: '',
      bugFixed: '',
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      status: filterOptions.firmware.status,
      logFilter: {
        custom: {
          opts: [],
          value: 'any'
        },
        date: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '1 month', value: 'month'}
          ],
          value: 'any'
        },
        category: {
          opts: [], // dynamic generated by $route.name
          value: 'any'
        },
        domain: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'Intri', value: 'intri'},
            {label: 'Eagleyes', value: 'eagleyes'},
            {label: 'EvoIP', value: 'evoip'},
            {label: 'AV Media', value: 'avmedia'}
          ],
          value: 'any'
        },
        model: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'ITE', value: 'ite'},
            {label: 'ASPEED', value: 'aspeed'}
          ],
          value: 'any'
        }
      },
      isUpdate: false,
      isUpdatedAt: '',
      versionPlaceholder: 'V1.10.1',
      showInvalidMsg: false,
      md5: ''
    }
  },
  ready () {
    // set the category , model and  custom opts
    let optAny = {label: 'Any', value: 'any'}
    if (this.$route.name !== PI) {
      this.dynamicTitle = 'Switch Firmware Change Log'
      this.category = _.cloneDeep(SWITCH_CATEGORY)
      this.selectedCategory = 'swix1'
      this.logFilter.category.opts = _.cloneDeep(SWITCH_CATEGORY)
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(SWITCH_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      this.selectedCustom = 'lantech'
      this.customOpts = SWITCH_CUSTOM
      this.selectedModel = 'all'
    } else {
      this.dynamicTitle = 'Smart-Controller Firmware Change Log'
      this.category = _.cloneDeep(PI_CATEGORY)
      this.selectedCategory = PI
      this.logFilter.category.opts = _.cloneDeep(PI_CATEGORY)
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(PI_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      this.selectedCustom = 'gomax'
      this.customOpts = PI_CUSTOM
      this.selectedModel = 'ite'
      this.modelOpts = [
        {label: 'ITE', value: 'ite'},
        {label: 'ASPEED', value: 'aspeed'}
      ]
      this.selectedDomain = 'intri'
      this.domainOpts = [
        {label: 'Intri', value: 'intri'},
        {label: 'Eagleyes', value: 'eagleyes'},
        {label: 'EvoIP', value: 'evoip'},
        {label: 'AV Media', value: 'avmedia'}
      ]
    }
    this.logFilter.category.value = this.firmwareInfo.category !== '' ? _.find(this.logFilter.category.opts, {label: this.firmwareInfo.category}).value : 'any'
    this.logFilter.custom.value = this.firmwareInfo.custom !== '' ? _.find(this.customOpts, {label: this.firmwareInfo.custom}).value : 'any'
    this.logFilter.date.value = 'any'
    store.dispatch('firmwareInfoDelete')
  },
  firebase () {
    return {
      firmware: getFirmwareRef(),
      switch: getFwSwitchRef().orderByChild('updatedAt'),
      pi: getFWPiRef().orderByChild('updatedAt')
    }
  },
  computed: {
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    sortMethodOpts () {
      if (this.$route.name === PI) {
        return [
          {
            label: 'Sort by Release Date',
            value: 'createdAt'
          },
          {
            label: 'Sort by Update Time',
            value: 'updatedAt'
          },
          {
            label: 'Sort by Category',
            value: 'category'
          },
          {
            label: 'Sort by Version',
            value: 'version'
          },
          {
            label: 'Sort by Domain',
            value: 'domain'
          },
          {
            label: 'Sort by Model',
            value: 'model'
          },
          {
            label: 'Sort by Custom',
            value: 'custom'
          }
        ]
      } else {
        return [
          {
            label: 'Sort by Release Date',
            value: 'createdAt'
          },
          {
            label: 'Sort by Update Time',
            value: 'updatedAt'
          },
          {
            label: 'Sort by Category',
            value: 'category'
          },
          {
            label: 'Sort by Version',
            value: 'version'
          }
        ]
      }
    },
    totalLength () {
      return this.customFilteredTotalLog.length
    },
    totalLog () {
      const { name, asc: isAsc } = this.sortMethod
      let data = this.$route.name === PI ? this.pi : this.switch
      if (name === 'version') {
        return naturalSorting(data, 'version', isAsc ? 'asc' : 'desc')
      } else {
        return _.orderBy(data, [name], [isAsc ? 'asc' : 'desc'])
      }
    },
    dateFilteredTotalLog () {
      return this.totalLog.filter(p => {
        return this.logFilter.date.value !== 'any' ? moment(p.updatedAt).isBetween(moment().subtract(1, 'months'), moment()) : true
      })
    },
    categoryFilteredTotalLog () {
      return this.dateFilteredTotalLog.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
    },
    domainFilteredTotalLog () {
      return this.categoryFilteredTotalLog.filter(p => {
        return this.logFilter.domain.value !== 'any' ? p.domain === this.logFilter.domain.value : true
      })
    },
    modelFilteredTotalLog () {
      return this.domainFilteredTotalLog.filter(p => {
        return this.logFilter.model.value !== 'any' ? p.model === this.logFilter.model.value : true
      })
    },
    statusFilteredTotalLog () {
      switch (this.user.role) {
        case 'admin':
          return this.modelFilteredTotalLog
        default:
          return this.modelFilteredTotalLog.filter(p => {
            return p.status !== 'dev'
          })
      }
    },
    customFilteredTotalLog () {
      // update select.option for user permission
      if (!(typeof this.user.custom === 'undefined' && typeof this.user.role === 'undefined')) {
        switch (this.user.role) {
          case 'admin':
          case 'vendor':
            break
          case 'client':
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any' || obj.value.toLowerCase() === 'lantech' || obj.value.toLowerCase() === this.user.custom.toLowerCase())
            break
          default:
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any')
            break
        }
      }
      return this.statusFilteredTotalLog.filter(p => {
        return this.logFilter.custom.value !== 'any'
        ? p.custom === this.logFilter.custom.value
        // filter data in user-permission clustered custom-option
        : typeof (_.find(this.logFilter.custom.opts, {value: p.custom})) !== 'undefined'
      })
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type,
        title,
        content
      })
    },
    handleDownload (url, e) {
      window.open(url)
    },
    getModelForUI,
    getCustomForUI,
    getSmartControllerClass (model) {
      switch (model) {
        case 'ite': return 'ite_color_bg'
        case 'aspeed': return 'aspeed_color_bg'
        case 'default': return 'base_black base_grey_bg'
      }
    },
    getIconSrc (category) {
      return {
        'smart-controller': '/static/svg/smart_controller.svg',
        'swix1': '/static/svg/core1.svg',
        'swix2': '/static/svg/core2.svg',
        'wrouter': '/static/svg/ap.svg',
        'router': '/static/svg/router.svg',
        'routerx': '/static/svg/routerx.svg'
      }[category]
    },
    handleShowModal (which, key, index) {
      console.log('key', key)
      // console.log('index', index + this.pageStart)

      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add firmware'
        this.isUpdate = false
        this.okText = 'Add'
        this.bugFixed = ''
        this.feature = ''
        this.version = ''
        this.url = ''
        this.testReportUrl = ''
        this.modalCb = this.applyUpload
        this.md5 = ''
      } else if (which === 'update') {
        this.modalTitle = 'Edit firmware'
        this.isUpdate = true
        let { updatedAt = '', bugFixed = '', feature = '', version, url, testReportUrl = '', domain = '', model, custom, category, status, md5 = '' } = this.customFilteredTotalLog[index + this.pageStart]
        // console.log(version)
        this.isUpdatedAt = ''
        this.isUpdatedAt = moment(updatedAt).format('YYYYMMDD HH:mm:ss')
        this.bugFixed = bugFixed
        this.feature = feature
        this.selectedCategory = category
        this.selectedDomain = domain
        this.selectedModel = model
        this.selectedCustom = custom
        this.selectedStatus = status
        this.url = url
        this.testReportUrl = testReportUrl
        this.okText = 'Update'
        this.modalCb = this.applyUpdate
        this.version = version
        this.md5 = md5
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    isVersionValid () {
      if (this.selectedModel === 'ite') {
        return this.version.startsWith('sciV')
      } else if (this.selectedModel === 'aspeed') {
        return this.version.startsWith('scaV')
      } else {
        return true
      }
    },
    applyUpload () {
      this.showInvalidMsg = false
      let key = ''
      if (this.$route.name !== PI) {
        key = 'switch'
        this.selectedModel = 'all'
      } else {
        key = 'pi'
        if (!this.isVersionValid()) {
          this.showInvalidMsg = true
          this.alert('danger', '', 'Invalid version')
          return
        }
      }
      let toPush = {
        createdAt: fb.database.ServerValue.TIMESTAMP,
        domain: this.selectedDomain,
        model: this.selectedModel,
        url: this.url,
        testReportUrl: this.testReportUrl,
        version: this.version,
        status: this.selectedStatus,
        feature: this.feature,
        bugFixed: this.bugFixed,
        custom: this.selectedCustom,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        category: this.selectedCategory,
        md5: this.md5
      }
      this.$firebaseRefs[key].push(toPush)
      this.showModal = false
    },
    async applyUpdate () {
      let key = ''
      if (this.selectedCategory !== PI) {
        this.selectedModel = 'all'
        key = 'switch'
      } else {
        key = 'pi'
        if (!this.isVersionValid()) {
          this.showInvalidMsg = true
          this.alert('danger', '', 'Invalid version')
          return
        }
      }
      let createdAt = ''
      await this.$firebaseRefs[key].once('value').then(snapshot => {
        let snap = snapshot.val()
        for (let i of Object.keys(snap)) {
          if (i === this.editingKey) {
            createdAt = snap[i].createdAt
            break
          }
        }
      })
      let update = {}
      update[this.editingKey] = {
        createdAt: createdAt,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        domain: this.selectedDomain,
        model: this.selectedModel,
        custom: this.selectedCustom,
        url: this.url,
        testReportUrl: this.testReportUrl,
        version: this.version,
        status: this.selectedStatus,
        feature: this.feature,
        bugFixed: this.bugFixed,
        category: this.selectedCategory,
        md5: this.md5
      }
      this.$firebaseRefs[key].update(update)
      this.showModal = false
    },
    applyDelete () {
      if (this.editingCategory !== PI) {
        this.$firebaseRefs.switch.child(this.editingKey).remove()
      } else {
        this.$firebaseRefs.pi.child(this.editingKey).remove()
      }
      this.showDeleteConfirm = false
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    },
    selectedModel (nv) {
      switch (nv) {
        case 'all':
          this.versionPlaceholder = 'V1.10.1'
          break
        case 'ite':
          this.versionPlaceholder = 'sciV1.10.1'
          if (!this.version.startsWith('sciV') && !this.isUpdate) this.version = ''
          break
        case 'aspeed':
          this.versionPlaceholder = 'scaV1.10.1'
          if (!this.version.startsWith('scaV') && !this.isUpdate) this.version = ''
          break
      }
    }
  },
  route: {
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
// .container{
//   max-width: 1150px;
// }
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{

  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}

.device_icon {
  &.smart-controller {
    // &.ite{
    //   background-color: hsl(337, 43%, 60%);
    // }
    // &.aspeed{
    //   background-color: hsl(105, 43%, 60%);
    // }
    &.intri {
      background-color: rgb(189, 55, 100);
    }
    &.eagleyes {
      background-color: rgb(0, 17, 255);
    }
    &.evoip {
      background-color: hsl(105, 43%, 60%);
    }
    &.avmedia {
      background-color: rgb(255, 196, 3);
    }
  }
  &.swix1            { background-color: hsl(92,  43%, 60%); }
  &.swix2            { background-color: hsl(24,  54%, 60%); }
  &.wrouter          { background-color: hsl(192, 43%, 60%); }
  &.router           { background-color: hsl(293, 43%, 60%); }
  &.routerx           { background-color: hsl(293, 37%, 57%); img {
    width: 40px;
    height: 40px;
  }}
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  overflow: hidden;
}
.badge_group{
  padding-right: 40px;
}
.customized__badge{
  &.dev{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-37px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-50px;
  }
  &.beta{
    @include genRightCornerBadge(50px, 18px, 14px, $beta, #000);
    right:-35px;
  }
  &.disabled{
    @include genRightCornerBadge(50px, 18px, 14px, $disabled, #fff);
    right:-56px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.intri {
  color: rgb(189, 55, 100);
}
.eagleyes {
  color: rgb(0, 17, 255);
}
.evoip {
  color: rgb(96, 191, 28);
}
.avmedia {
  color: rgb(255, 196, 3);
}
</style>



// WEBPACK FOOTER //
// FwChangeLog.vue?c7e09522